import gql from 'graphql-tag';
import * as React from 'react';
import { Query } from 'react-apollo';
import { Container, Input } from 'semantic-ui-react';

const searchQuery = gql`
  query searchQuery($word: String!) {
    lookup(word: $word) {
      word
      found
      etymonline
    }
  }
`;

export class IndexContainer extends React.Component {
  public render() {
    return (
      <Container text={true}>
        <Query 
          query={searchQuery}
          variables={{
            word: ''
          }}
        >
          {({ loading, error, data, refetch }) => {
            return (
              <div>
                <div>
                  <Input
                    size="large" 
                    icon="search" 
                    placeholder="Lookup word..." 
                    // tslint:disable-next-line:jsx-no-lambda
                    onKeyPress={(e: any) => e.key === 'Enter' ? refetch({ word: e.target.value }) : null}
                  />
                </div>
                {loading && (
                  <p>Loading...</p>
                )}
                {error && (
                  <p>Error! {error.message}</p>
                )}
                {data && data.lookup && (
                  <>
                    <h3>{data.lookup.word}</h3>
                    <p>{data.lookup.etymonline}</p>
                  </>
                )}
              </div>
            );
          }}
        </Query>
      </Container>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/index.tsx